module.exports = __webpack_public_path__ + "static/media/utsushimi-camie-lose.2bb99ab5.png";